/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { useProjectTheme } from '@jira/platform__project-theme-page-container/src/controllers/project-theme/index.tsx';
import { ThemedContentLayout } from '@jira/platform__project-theme-page-container/src/ui/project-theme-wrapper/ProjectThemeWrapper.tsx';
import { RenderTracerMark } from '@jira/platform__observability-render-tracer/src/main.tsx';
import SpaEntry, { type Props } from '@jira/platform__spa/src/index.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Props };

const SPA_TRACE_KEY = 'spa';

const DefaultLayoutContent = (props: Props) => {
	const { isInset, hasTheming } = useProjectTheme();

	const renderContent = (
		<>
			<RenderTracerMark traceKey={SPA_TRACE_KEY} type="start" />
			<SpaEntry {...props} />
			<RenderTracerMark traceKey={SPA_TRACE_KEY} type="end" />
		</>
	);

	if (hasTheming) {
		return (
			<ThemedContentLayout appearance={isInset ? 'inset' : 'default'}>
				{renderContent}
			</ThemedContentLayout>
		);
	}

	return renderContent;
};

const useRouterRoute = createRouterSelector((state) => state.route);
export const Content = (props: Props): React.JSX.Element => {
	const { LayoutOverrideComponent } = useRouterRoute();
	if (LayoutOverrideComponent !== undefined) {
		return (
			<>
				<RenderTracerMark traceKey={SPA_TRACE_KEY} type="start" />
				<SpaEntry {...props} />
				<RenderTracerMark traceKey={SPA_TRACE_KEY} type="end" />
			</>
		);
	}
	return <DefaultLayoutContent {...props} />;
};
